import type { IControlsProps } from './Controls'

import { styled } from '@linaria/react'
import { INDENTS } from 'vars/index'
import { AlignItems, Direction, Fluid, JustifyContent } from './Controls.h'

export const WrapperControls = styled.div<IControlsProps>`
  width: ${({ fluid }) =>
    fluid === Fluid.Horizontal || fluid === Fluid.Both ? '100%' : 'auto'};
  height: ${({ fluid }) =>
    fluid === Fluid.Vertical || fluid === Fluid.Both ? '100%' : 'auto'};
  display: inline-flex;
  flex-direction: ${({ direction }) => direction || Direction.Row};
  align-items: ${({ alignItems }) => alignItems || AlignItems.FlexStart};
  justify-content: ${({ justifyContent }) =>
    justifyContent || JustifyContent.FlexStart};
  gap: var(${INDENTS.INDENT_55});
  padding: ${({ paddings }) =>
    paddings && paddings.length
      ? paddings.map((item) => `var(${item})`)?.join(' ')
      : 0};

  & > :first-child {
    visibility: ${({ controlsState }) =>
      controlsState?.[0]?.visible ? 'visible' : 'hidden'};
  }

  & > :last-child {
    visibility: ${({ controlsState }) =>
      controlsState?.[1]?.visible ? 'visible' : 'hidden'};
  }
`
